import React from 'react';
import { Container } from '@mui/material';
import ProjectCard from './ProjectCard';

const projectData = [
  {
    heading: 'Senior AI Engineer',
    customer: 'PwC (Federal Government)',
    role: 'AI, Backend, Frontend, DevOps',
    description:
      'In this role, I developed AI models and applications to enhance government services. My responsibilities included leveraging LLM models and createing datapipelines, building backend services to support AI functionalities, and creating user-friendly frontend interfaces for seamless interaction with AI-powered features.',
    skills: ['Pyhton', 'FastAPI', 'React', 'Typescript' ,'Langchain','OpenRouter' ,'Azure','CICD','Git','Linux','NLP','Machine Learning','Data Engineering'],
  },
  {
    heading: 'Cloud Platform Design',
    customer: 'Deutsche Bahn',
    role: 'Cloud Engineer',
    description:
      'As a Cloud Infrastructure Engineer, I was responsible for designing, implementing, and maintaining scalable cloud environments using Infrastructure as Code (IaC) tools, specifically Ansible and Terraform..',
    skills: ['Terraform', 'Ansible','Rundeck', 'AWS', 'Lambda', 'IAM','S3','RDS','ECS','Route53','DynamoDB','Docker','CICD','GITLAB','Shell','Git','CDK','Python','Linux','Starburst','Nginx','Oracle','Kubernetes','Airflow'],
  },
  {
    heading: 'AIOps Platform Development',
    customer: 'Seven Principles',
    role: 'Cloud Engineer, Data Engineer, Data Analyst',
    description:
      'In my role, I was responsible for configuring metric collectors such as Filebeat, Logstash, and Fluent Bit, as well as setting up and administering Kafka clusters. I developed TensorFlow applications to analyze and forecast metric and log data, and created dashboard solutions using Superset and Grafana. Additionally, I designed ETL pipelines based on Apache NiFi and managed various components—including Kafka, Grafana, Airflow, PostgreSQL, pgAdmin, and Superset—using Docker. ',
    skills: ['Python', 'Tensorflow', 'Nifi', 'Docker', 'PostgreSQL','AWS','Filebeat','Logstash','Grafana','Prometheus','FastAPI','Kafka','Airflow','Fluentbit','Terraform','Git','Machine Learning','Linux'],
  },
  {
    heading: 'Application Management',
    customer: 'Mercedes Benz Bank',
    role: 'System Engineer, Administrator',
    description:
      'As a member of the "Special Application" service team, I managed and operated non-standard applications, encompassing both Linux and Windows platforms across various application servers, as well as standalone applications. Additionally, I administered OpenShift along with its associated registry.',
    skills: ['Linux', 'Git', 'Open Shift', 'Nginx','Tomcat','Ansible','Confluence','Artifactory','Container Registry','Puppet','Python','Helm','Jira','Ansible Tower'],
  },
  {
    heading: 'Cloud Developer',
    customer: 'Event Hotel',
    role: 'Cloud & DevOps',
    description:
      'In this role, I designed and implemented cloud infrastructure for an automated hotel check-in application, administering the AWS account and automating resource provisioning with Ansible. I developed a CI/CD pipeline to deploy new releases from a private container registry to a Docker environment on EC2 instances. Additionally, I established a monitoring system using Docker, Prometheus, and Grafana.',
    skills: ['AWS', 'Docker', 'Ansible', 'CICD','Cloud Solution','Linux',"Postgres",'Grafana','Traefik','Prometheus','Python'],
  },
  {
    heading: 'Web Applicaton Cloud Infrastructure',
    customer: 'Deutsche Post',
    role: 'Cloud & DevOps',
    description:
      'I managed the AWS account through Ansible automation, creating and administering infrastructure and deployment processes. Additionally, I designed and implemented the project\'s cloud infrastructure.',
    skills: ['React', 'AWS', 'Ansible', 'Docker','SQL','Linux','Grafana','Premetheus'],
  },
  {
    heading: 'My CV Website',
    customer: 'Self-Project',
    role: 'Designer & Developer',
    description:
      'The very website you see, developed with react and hosted on aws using Route 53. Provisioned with CDK and CICD Pipeline on AWS CodeDeploy.',
    skills: ['React', 'CSS3', 'Material-UI','AWS','CodeDeploy'],
  },
];

const ProjectsList = () => {
  return (
    <Container  >
      {projectData.map((project, index) => (
        <ProjectCard key={index} {...project} />
      ))}
    </Container>
  );
};

export default ProjectsList;
